import { SearchIcon } from "lucide-react";
import TextField from "../TextField";
import { DatePickerWithRange } from "../ui/dateRangePicker";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { useFilterDate } from "@/common/hooks/useFilterDate";
import Table from "../Table";
import { logChangesTableColumns } from "@/common/constants/logChangesTableColumns";
import useLogChanges from "@/common/hooks/queries/useLogChanges";
import { logRelatedTypes } from "@/common/constants/logRelatedTypes";
import { Mapper } from "@/common/services/mapper";
import { LogChangesTransformer } from "@/common/services/logChangesTransformer";

interface LogChangesTable {
  type: keyof typeof logRelatedTypes;
  id?: string;
  hideSearch?: boolean;
}

const LogChangesTable = ({ type, id, hideSearch }: LogChangesTable) => {
  const { filterParams, setFilterParams } = useFilterParams();

  const { date, formattedDate } = useFilterDate(filterParams);

  const { data: logChanges, meta, isFetching } = useLogChanges({
    filters: {
      search: filterParams.search,
      page: filterParams.page,
      changeHistoryTypeKey: type,
      relatedToOrItemId: id,
      createdAtGt: formattedDate.from,
      createdAtLt: formattedDate.to,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: LogChangesTransformer.tableTransformer("Admin::Log::Requests::Filter"),
    })
  });

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        {!hideSearch && (
          <TextField
            LeftIcon={<SearchIcon />}
            placeholder="Pesquisar por ID"
            className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
            value={filterParams.search}
            onChange={(e: any) => setFilterParams((params) => ({ ...params, search: e.target.value }))}
          />
        )}

        <div className="flex">
          <DatePickerWithRange date={date} setDate={(date) => setFilterParams((params) => ({ ...params, date }))} />
        </div>
      </div>

      <div>
        <Table
          className="max-h-[calc(100vh-268px-3rem)]"
          columns={logChangesTableColumns}
          rows={logChanges}
          page={filterParams.page ? Number(filterParams.page) : 1}
          totalCount={meta.total}
          totalPages={meta.total_pages}
          isLoadingData={isFetching}
          rowEmptyValue="--"
          setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          hasPagination
        />
      </div>
    </div>
  );
};

export default LogChangesTable;
